import { useState } from "react";
import { Card } from "@/components/Shared/Card";
import Footer from "@/components/Shared/Footer";
import { LoginForm } from "@/components/Auth/LoginForm";
import { ResetPassForm } from "@/components/Auth/ResetPassForm";
import { Content } from "@/components/ui/ContentArea";
import type { AuthContextType } from "@/hooks/useAuth";
import { useNavigate } from "react-router-dom";

export type CardMessageType = {
	msg: string;
	type: string;
} | null;
export function LoginPage() {
	const [cardMessage, setCardMessage] = useState<CardMessageType>(null);
	const [isResetting, setIsResetting] = useState(false);
	const navigate = useNavigate();

	const onSuccess = (result: AuthContextType["user"]) => {
		if (result == null) return;

		if (result.userType == "EMPRESA") void navigate("/user/");
		else void navigate("/admin/");
	};

	return (
		<Content>
			<div className="flex flex-col items-center justify-center flex-1">
				<h1 className="grid grid-cols-2 gap-10">
					<img src="/img/Logo_Cluster_Completo.svg" className="h-30"></img>
					<img src="/img/Logo_Wunder_Completo.svg" className="h-30"></img>
				</h1>

				{cardMessage && (
					<Card
						className={`max-w-md mt-5 text-wrap border-l-4 border-solid ${"border-" + cardMessage.type}`}
					>
						{/* Ensure the css classes are loaded */}
						<div className="border-info border-error border-warning border-success" />
						<div id="login_error">{cardMessage.msg}</div>
					</Card>
				)}

				<Card style={{ minWidth: "450px", margin: "16pt" }}>
					{isResetting == false && (
						<LoginForm
							setCardMessage={setCardMessage}
							setIsResetting={setIsResetting}
							onSuccess={onSuccess}
						/>
					)}
					{isResetting == true && (
						<ResetPassForm
							setCardMessage={setCardMessage}
							setIsResetting={setIsResetting}
						/>
					)}
				</Card>
			</div>
			<Footer />
		</Content>
	);
}
